// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {BootstrapVue} from 'bootstrap-vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import moment from 'moment'
import VoerroTagsInput from '@voerro/vue-tagsinput'
import SearchPlugin from './plugins/SearchPlugin'
import '@fortawesome/fontawesome-free/css/all.css'
import Vuetify from 'vuetify'
// css
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@voerro/vue-tagsinput/dist/style.css'
import './assets/css/bootstrap-multiselect-min.css'
import './assets/css/main.css'
import './assets/css/overwrite.css'


// Google Login
import GSignInButton from 'vue-google-signin-button'

import App from './App.vue'
import router from './router'
import store from './store/index'
import filters from './filters/index'
import config from '../config'
import fb from './facebook'

// Telephone input
import VueTelInput from 'vue-tel-input'

// Sidebar menu
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

// Disqus
import VueDisqus from 'vue-disqus'

// Google Login
Vue.use(GSignInButton)

// Vue.use(VueDisqus)
Vue.use(VueDisqus)
Vue.use(VueSidebarMenu)
Vue.use(VueTelInput)

Vue.use(Vuetify)

// set the custom filters as global
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('tags-input', VoerroTagsInput)

Vue.use(BootstrapVue)
Vue.prototype.moment = moment

Vue.config.productionTip = false
Vue.prototype.apiBaseURL = () => { return config.api.baseURL }

Vue.use(SearchPlugin, router)
export const eventBus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  // vuetify: new Vuetify(),
  router,
  store,
  components: {App},
  filters,
  template: '<app/>'
})
// new Vue({
//   render: h => h(App)
// }).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js